export const MINIMUM_FULL_NAME_CHARACTERS = 2;
export const MINIMUM_MESSAGE_VALUE = 5;


export const DEFAULT_VALUES = {
    skills: ""
};